import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/menuIcons/gear.svg'
import _imports_1 from '@/assets/images/menuIcons/person-plus.svg'
import _imports_2 from '@/assets/images/menuIcons/book-vertical.svg'
import _imports_3 from '@/assets/images/menuIcons/magnifyingglass.svg'
import _imports_4 from '@/assets/images/menuIcons/Logos.svg'


const _hoisted_1 = { class: "menu" }
const _hoisted_2 = { class: "avatar-container" }
const _hoisted_3 = {
  class: "col gap-04 bg-modal",
  style: {"width":"20rem"}
}
const _hoisted_4 = { class: "font-m size-m mleft-04" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "font-m size-m mleft-04" }
const _hoisted_7 = {
  key: 0,
  class: "line-h"
}
const _hoisted_8 = { class: "font-m size-m mleft-04" }
const _hoisted_9 = { class: "font-m size-m mleft-04" }
const _hoisted_10 = { class: "menu-body" }
const _hoisted_11 = { class: "menu-modal-icon" }
const _hoisted_12 = { class: "menu-modal-icon" }
const _hoisted_13 = { class: "flex-center" }
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "divider"
}
const _hoisted_16 = {
  class: "col gap-04 bg-modal",
  style: {"width":"20rem"}
}
const _hoisted_17 = { class: "font-m size-m mleft-04" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "font-m size-m mleft-04" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "font-m size-m mleft-04" }
const _hoisted_22 = { class: "font-m size-m mleft-04" }

import dashbAdmin from '@/views/patientMain/dashbAdmin/dashbAdmin.vue';

import {computed, onMounted, ref} from "vue";
import {MenuItem, Routes} from "@/models/layout.model";
import {useRoute} from "vue-router";
import {useAppUserStore} from "@/stores/appUser";
import {useInteropLuStore} from "@/stores/interopLu";
import {useReferenceStore} from "@/stores/reference";
import {useUiStore} from "@/stores/ui";
import {authStore} from "@/stores/useAuthStore";
import mainMenuItem from "@/views/mainMenu/mainMenuItem.vue";
import dashbSettings from "@/views/officeMain/dashbSettings.vue"
import SessionStorageService from "@/services/SessionStorageService";
import router from "@/router";
import SharedService from "@/services/SharedService";
import StringService from "@/services/StringService";
import CombinedReference from '@/views/patientMain/combinedReference/combinedReference.vue';
import EsSearchPatientModal from '@/components/modals/patient/esSearchPatientModal.vue';
import {useCurrentEntryStore} from "@/stores/currentEntry";
import {useI18n} from "vue-i18n";
import { usePermissionsStore } from "@/stores/permissionsStore";
import onboardingTutorialsEmbed from '@/views/mainMenu/onboardingTutorialsEmbed.vue';

import { Permissions, PermissionsAdmin } from "@/models/permissions.model";


export default /*@__PURE__*/_defineComponent({
  __name: 'mainMenu',
  setup(__props) {

const currentEntryStore = useCurrentEntryStore();
const appUserStore = useAppUserStore();
const interopLuStore = useInteropLuStore();
const referenceStore = useReferenceStore();
const permissionsStore = usePermissionsStore();

const route = useRoute();

const { t } = useI18n();

const date = new Date();
const dayOfMonth = date.getDate();

const uiStore = useUiStore()
const auth = authStore();
const dropd = ref('');
const dropup = ref('');
const dropHelp = ref(false);


const accessTask = ref<boolean>(false);
const accessAccounting = ref<boolean>(false);
const accessPatient = ref<boolean>(false);
const accessFastPatientCreation = ref<boolean>(false);
const accessCalendar = ref<boolean>(false);
const accessAdmin = ref<boolean>(false);
const openModal = ref<boolean>(false);

const mailTechnique = process.env.VUE_APP_MAIL_TECHNIC;
const mailSuggest = process.env.VUE_APP_MAIL_SUGGESTION;

const logout = () => {
  auth.stopTokenRefresh();

  SessionStorageService.clear();

  router.push({ path: "/login" }).then(() => {
    location.reload();
  })
}

const currInstituteUuid = computed(() => {
  if (!appUserStore.currentHealthGroupMembership) {return "";}
  return appUserStore.getCurrentInstituteWithRole().instituteWithRoleId;
});

const userNameTerm = computed(() => {
  if (!appUserStore.currentHealthGroupMembership) {
    return ""
  }

  const pwr = appUserStore.currentHealthGroupMembership.pwr

  return StringService.getInitial(pwr.lastName ?? "", pwr.firstName ?? "")
});

const version = computed(
    () => process.env.VUE_APP_VERSION
);

const menuItems = ref<MenuItem[]>([]);

const healthGroupMemberships = computed(() => {
  if (!appUserStore.currentAppUserData) {return []}
  return appUserStore.currentAppUserData.healthGroupMemberships
})

const getIcon = (icon: string, isFillIcon: boolean) => {
  return SharedService.getIcon(icon, isFillIcon, 'menuIcons');
};

const hasPatientOpen = () => {
  return currentEntryStore.currentPatient?.personWithRoleId;
}
const getPatientRoute = () => {
  if (hasPatientOpen()) {
    return `/${Routes.PATIENT}/` + currentEntryStore.currentPatient.personWithRoleId;
  } 
  return ""
}

function goFullScreen() {
  document.documentElement.requestFullscreen()
  uiStore.setFullScreen(true)
  dropd.value = ""
}

async function setCurrentHealthProMember(relation) {
  const relationId = relation.relationshipId
  dropd.value = ""
  //await appuserapi.switchAppUserHealthGroup(relationId)
  appUserStore.setCurrentHealthGroupMembership(relation.instituteWithRole)
}

async function initialize() {

  accessTask.value = await permissionsStore.checkPermission(Permissions.task.ACCESS_TASK.name);
  accessAccounting.value = await permissionsStore.checkPermission(Permissions.accounting.ACCESS_ACCOUNTING.name);
  accessPatient.value = await permissionsStore.checkPermission(Permissions.patient.READ_PATIENT_DATA.name);
  accessCalendar.value = await permissionsStore.checkPermission(Permissions.planning.ACCESS_PLANNING.name);
  accessAdmin.value = await permissionsStore.checkPermission(PermissionsAdmin.esklepios.ADMIN_ESKLEPIOS);

  const currentHealthGroupMembership = await appUserStore.getCurrentHealthGroupMembership();
  accessFastPatientCreation.value = currentHealthGroupMembership?.instituteWithRole?.fastPatientCreationActive;

  menuItems.value = [
  { route: `/${Routes.CALENDAR}`, icon: `calendar-${dayOfMonth}`, label: "layout.agenda", visible: accessCalendar.value },
  { route: `/${Routes.TASK}`, icon: "bubble-checkmark", label: "layout.task", separator: true, visible: accessTask.value },
  { route: `/${Routes.FINANCE}`, icon: "creditcard", label: "layout.finance", visible: accessAccounting.value }
  ];
  
  //AppUser
  if (appUserStore.currentAppUserData == null) {
    appUserStore.setCurrentAppUserData()
  }
  if (appUserStore.commonAlerts == null) {
    appUserStore.setCommonAlerts()
  }
  if (appUserStore.currentHealthGroupMembership == null) {
    await appUserStore.getCurrentHealthGroupMembership()
  }
  //Lists
  //References
  referenceStore.getAllDosageAndMedicReferences()
  referenceStore.setAdministrationRouteReference()

  if (!interopLuStore.interopLuData) {
    interopLuStore.setInteropLuData()
  }
}

const goToAdmin = () => {
  dropd.value = "";
  router.push({
      name: Routes.ADMIN
  });
}

const goToSettings = () => {
  dropd.value = "";
  openModal.value = true;
}

const closeFormModal = () => {
  openModal.value = false;
  dropHelp.value = false;
}

const openHelpModal = () => {
  dropup.value = ""; 
  dropHelp.value = true;
}

const showPatientModal = computed(() => {
  return currentEntryStore.showPatientModal;
})

const closeAdminModal = () => {
  currentEntryStore.closePatientModal();
}

const refreshHealthPro = () => {
  appUserStore.setRefreshHealthProCalendar(true);
  appUserStore.setRefreshHealthProInstitute(true);
}

onMounted(() => {
  initialize()
})

return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_itemModal = _resolveComponent("itemModal")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_dropdownBox, {
        modelValue: dropd.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dropd).value = $event)),
        openOn: "optionMenu"
      }, {
        dropd: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_buttonGroup, {
              class: "w-full",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goFullScreen()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "fullScreen",
                  styles: "size-m"
                }),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('menu.fullscreen')), 1)
              ]),
              _: 1
            }),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "line-h" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(healthGroupMemberships.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_buttonGroup, {
                key: index,
                class: "w-full item-center",
                onClick: ($event: any) => (setCurrentHealthProMember(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "building",
                    styles: "size-m",
                    class: _normalizeClass({'img-primary' : item.instituteWithRole.instituteWithRoleId === currInstituteUuid.value})
                  }, null, 8, ["class"]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["font-m size-m mleft-04", {'txt-primary' : item.instituteWithRole.instituteWithRoleId === currInstituteUuid.value}])
                  }, _toDisplayString(item.instituteWithRole.instituteShortName), 3),
                  (item.instituteWithRole.instituteWithRoleId === currInstituteUuid.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(SharedService).getIcon('checkmark', false, 'shareIcons'),
                        class: "mleft-04 img-primary"
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128)),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "line-h" }, null, -1)),
            _createVNode(_component_buttonGroup, {
              class: "w-full item row-center",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goToSettings()))
            }, {
              default: _withCtx(() => [
                _cache[9] || (_cache[9] = _createElementVNode("img", {
                  src: _imports_0,
                  alt: "gear"
                }, null, -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('menu.settings')), 1)
              ]),
              _: 1
            }),
            (accessAdmin.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
              : _createCommentVNode("", true),
            (accessAdmin.value)
              ? (_openBlock(), _createBlock(_component_buttonGroup, {
                  key: 1,
                  class: "w-full item row-center",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (goToAdmin()))
                }, {
                  default: _withCtx(() => [
                    _cache[10] || (_cache[10] = _createElementVNode("img", {
                      src: _imports_1,
                      alt: "gear"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('menu.admin')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "line-h" }, null, -1)),
            _createVNode(_component_buttonGroup, {
              class: "w-full",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (logout()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "logOut",
                  styles: "size-m"
                }),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('menu.logout')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(userNameTerm.value), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (showPatientModal.value)
        ? (_openBlock(), _createBlock(dashbAdmin, {
            key: 0,
            "is-open": showPatientModal.value,
            onModalClose: closeAdminModal
          }, null, 8, ["is-open"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_itemModal, {
            center: true,
            uiId: "referenceFromMiddle"
          }, {
            modal: _withCtx(() => [
              _createVNode(CombinedReference)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, null, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("img", {
                    class: "icon-container img-white",
                    src: _imports_2
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _createVNode(_component_itemModal, {
            ref: "searchPatientModalRef",
            uiId: "searchPatientModal"
          }, {
            modal: _withCtx(() => [
              _createVNode(EsSearchPatientModal, {
                class: "item-modal",
                "fast-patient-creation": accessFastPatientCreation.value,
                onModalClose: _cache[5] || (_cache[5] = ($event: any) => (_unref(uiStore).setModalUiId('')))
              }, null, 8, ["fast-patient-creation"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_buttonGroup, null, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createElementVNode("img", {
                    class: "icon-container img-white",
                    src: _imports_3
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 512)
        ], 512), [
          [_vShow, accessPatient.value]
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "divider" }, null, -1)),
        _withDirectives(_createVNode(_component_router_link, {
          to: getPatientRoute(),
          class: _normalizeClass(["menu-item", { 'active-menu-item': _unref(route).path.includes(_unref(Routes).PATIENT), 'noHover' :  !hasPatientOpen()}])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                class: _normalizeClass(["icon-container img-white", { 'disable' :  !hasPatientOpen()}]),
                src: getIcon('person', _unref(route).path.includes(_unref(Routes).PATIENT)),
                alt: 'layout.patient'
              }, null, 10, _hoisted_14)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["menu-text", {'disable' :  !hasPatientOpen()}])
            }, _toDisplayString(_unref(t)('layout.patient')), 3)
          ]),
          _: 1
        }, 8, ["to", "class"]), [
          [_vShow, accessPatient.value]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (item.visible)
              ? (_openBlock(), _createBlock(mainMenuItem, {
                  key: 0,
                  route: item.route,
                  icon: getIcon(item.icon, _unref(route).path === item.route),
                  label: item.label,
                  isActive: _unref(route).path === item.route
                }, null, 8, ["route", "icon", "label", "isActive"]))
              : _createCommentVNode("", true),
            (item.separator)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _createVNode(_component_dropdownBox, {
        modelValue: dropup.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dropup).value = $event)),
        openOn: "logoMenu",
        combo: ""
      }, {
        dropup: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_buttonGroup, {
              class: "w-full",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (openHelpModal()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "help",
                  styles: "size-m"
                }),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('menu.help')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_buttonGroup, { class: "w-full" }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: 'mailto:' + _unref(mailSuggest),
                  class: "link w-full main-h"
                }, [
                  _createVNode(_component_svg_item, {
                    icon: "bulb",
                    styles: "size-m"
                  }),
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('menu.idea')), 1)
                ], 8, _hoisted_18)
              ]),
              _: 1
            }),
            _createVNode(_component_buttonGroup, { class: "w-full" }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: 'mailto:' + _unref(mailTechnique),
                  class: "link w-full main-h"
                }, [
                  _createVNode(_component_svg_item, {
                    icon: "help",
                    styles: "size-m"
                  }),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('menu.contactSupport')), 1)
                ], 8, _hoisted_20)
              ]),
              _: 1
            }),
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "line-h" }, null, -1)),
            _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)('menu.version', {version: version.value})), 1)
          ])
        ]),
        default: _withCtx(() => [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "logo-container" }, [
            _createElementVNode("img", {
              src: _imports_4,
              alt: "Logo",
              class: "logo"
            })
          ], -1))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(dashbSettings, {
      "is-open": openModal.value,
      onModalClose: closeFormModal,
      onRefreshHealthPro: _cache[8] || (_cache[8] = ($event: any) => (refreshHealthPro()))
    }, null, 8, ["is-open"]),
    (dropHelp.value)
      ? (_openBlock(), _createBlock(_component_itemModal, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(onboardingTutorialsEmbed, {
              "is-open": dropHelp.value,
              onModalClose: closeFormModal
            }, null, 8, ["is-open"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})